import TableHead from "./TableHead.js";
import TableBody from "./TableBody.js";
import { useSortableTable } from "../hooks/useSortableTable.js";

export default function Table({ caption, data, columns }) {
  const [tableData, handleSorting, delRow] = useSortableTable(data);

  return (
    <table className="ui unstackable celled table">
      <caption className="ui header">
        {caption}
      </caption>
      <TableHead columns={columns} handleSorting={handleSorting} />
      <TableBody columns={columns} tableData={tableData} delRow={delRow} />
    </table>
  );
}
